export const messengerTypeByIcon = {
  telegram: 'Telegram',
  whatsapp: 'WhatsApp',
} as const;

export const NONE_VALUE = '';

export const ARTICLE_STATIC_DATA = {
  article: {
    action: 'Blog',
    event: 'blog_data',
  },
  case: {
    action: 'Cases',
    event: 'cases_data',
  },
  insider: {
    action: 'Insider',
    event: 'insider_data',
  },
};

export const pageLevels = {
  main: 1,
  category: 2,
  page: 3,
};
